/**
 * Colors
 */
// Theme colors
export const PRIMARY_COLOR = '#0070ba';
export const ERROR_COLOR = '#d20000';
export const WARNING_COLOR = '#ff9600';
export const WHITE_COLOR = '#ffffff';

// Misc colors
export const DEFAULT_BORDER_COLOR = '#b7bcbf';
export const BORDER_FOCUSED_COLOR = '#009cde';
export const BUTTON_FOCUSED_COLOR = '#003087';
export const LANG_COUNTRY_DIVIDER_COLOR = '#d3d4d1';
export const NON_INPUT_BORDER_COLOR = '#cbd2d6';

// Disabled field colors
export const DISABLED_BACKGROUND_COLOR = '#ebecee';
export const DISABLED_BORDER_COLOR = '#b7bcbf';

// Page message colors
export const ERROR_MESSAGE_BACKGROUND_COLOR = '#fff7f7';
export const INFO_MESSAGE_BACKGROUND_COLOR = '#f5f7fa';
export const WARNING_MESSAGE_BACKGROUND_COLOR = '#fffbf5';

// Text colors
export const TEXT_COLOR = '#6c7378';
export const HEADER_COLOR = '#2c2e2f';
export const LINK_COLOR = '#0070ba';
export const SUB_HEADING_COLOR = '#687274';
